import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

function MobileStatsSummary({ stats }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="mb-4">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between bg-white rounded-xl px-4 py-3 border border-gray-200"
        style={{ minHeight: '48px' }}
      >
        <span className="text-base font-semibold text-gray-700">
          {stats.adults} Adults, {stats.minors} Children
        </span>
        <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`} />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${expanded ? 'max-h-40 mt-2' : 'max-h-0'}`}>
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-white rounded-xl p-3 border border-gray-200 text-center">
            <div className="text-xl font-bold text-green-600">{stats.adults}</div>
            <div className="text-sm text-gray-500">Adults</div>
          </div>
          <div className="bg-white rounded-xl p-3 border border-gray-200 text-center">
            <div className="text-xl font-bold text-blue-600">{stats.minors}</div>
            <div className="text-sm text-gray-500">Children</div>
          </div>
          <div className="bg-white rounded-xl p-3 border border-gray-200 text-center">
            <div className="text-xl font-bold text-amber-600">{stats.pendingInvites}</div>
            <div className="text-sm text-gray-500">Pending</div>
          </div>
          <div className="bg-white rounded-xl p-3 border border-gray-200 text-center">
            <div className="text-xl font-bold text-gray-500">{stats.treeOnly}</div>
            <div className="text-sm text-gray-500">Tree Only</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileStatsSummary
